import { render, staticRenderFns } from "./BusinessFrontPageTitlesSummaryCard.vue?vue&type=template&id=1c60681c&"
import script from "./BusinessFrontPageTitlesSummaryCard.vue?vue&type=script&lang=ts&"
export * from "./BusinessFrontPageTitlesSummaryCard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports